import React from 'react';
import {questionTypes} from '../../../../config/constants';
import MultipleChoiceQuestion from "./MultipleChoiceQuestion";
import ComboBoxQuestion from "./ComboBoxQuestion";
import TextInputQuestion from "./TextInputQuestion";
import CustomSweetAlert from "../../../helper/CustomSweetAlert";
import getErrorMessage from "../../../../config/ErrorMessage";
import GroupQuestion from "./GroupQuestion";
import QuestionDescription from "./partial/QuestionDescription";
import NoAnswerQuestion from "./NoAnswerQuestion";

const QuestionFactor = (props) => {
    const {question, index} = props;
    let answersComponent = null;
    switch (question.questionType) {
        case questionTypes.MULTIPLE_CHOICE:
            answersComponent = <MultipleChoiceQuestion key={question.questionCode} question={question}/>;
            break;
        case questionTypes.COMBO_BOX:
            answersComponent = <ComboBoxQuestion question={question}/>;
            break;
        case questionTypes.TEXT_INPUT:
            answersComponent = <TextInputQuestion question={question}/>;
            break;
        case questionTypes.NO_ANSWERS:
            answersComponent = <NoAnswerQuestion question={question} index={index}/>;
            break;
        case questionTypes.GROUP_QUESTION:
            answersComponent = <GroupQuestion question={question} index={index}/>;
            break;
        default:
            answersComponent =
                <CustomSweetAlert showConfirm={false} text={getErrorMessage("QUESTION_TYPE_NOT_FOUND")}/>;
            break;
    }

    return (
        <React.Fragment>
            <QuestionDescription question={question} questionIndex={index}/>
            {answersComponent}
        </React.Fragment>
    );
};

export default QuestionFactor;
